import React, { useContext } from "react";
import { PlusIcon } from "lucide-react";
import GlobalContext from "../../../context/GlobalCalendarContext";
export default function CreateEventButton() {
  const { setShowEventModal } = useContext(GlobalContext);
  return (
    <button
      onClick={() => setShowEventModal(true)}
      className="border p-2 rounded-full flex items-center shadow-md hover:shadow-2xl"
    >
      <PlusIcon size={22} className="text-gray-700 font-bold" />
      <span className="pl-3 pr-7"> Create</span>
    </button>
  );
}
